<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         isLoading: false,
      }
   },
   computed: {
      ...mapState({
         items: state => state.DashboardMppd.fayankes,
         tahun: state => state.DashboardMppd.tahun,
         refreshTimestamp: state => state.DashboardMppd.refreshTimestamp,
      }),
      fields() {
         return [
            {
               key: 'index', label: 'No', thClass: 'text-center', tdClass: 'text-center',
            },
            { key: 'nama', label: 'Nama Fayankes', thClass: 'text-left' },
            { key: 'kategori', label: 'Kategori', thClass: 'text-left' },
            {
               key: 'total', label: 'Jumlah', thClass: 'text-right', tdClass: 'text-right',
            },
         ]
      },
      topItems() {
         const sorted = [...this.items]
            .sort((a, b) => (b.total || 0) - (a.total || 0))
            .slice(0, 10)
            .map((item, index) => ({ ...item, index: index + 1 }))

         while (sorted.length < 10) {
            sorted.push({
               _placeholder: true, index: null, nama: '', kategori: '', total: null,
            })
         }

         return sorted
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getFayankes: 'DashboardMppd/getFayankes',
      }),
      async loadData(year) {
         if (this.isLoading) return
         this.isLoading = true
         try {
            await this.getFayankes(year)
         } finally {
            this.isLoading = false
         }
      },
      formatNumber(value) {
         return Number(value || 0).toLocaleString('id-ID')
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card class="card-wrapper h-100" body-class="p-0">
            <div class="card-header-content p-2 p-md-2">
               <div class="d-flex justify-content-between align-items-center">
                  <div>
                     <h4 class="mb-25">
                        Top 10 Fayankes
                     </h4>
                     <small class="text-muted">Tahun {{ tahun }}</small>
                  </div>
                  <b-spinner v-if="isLoading" small variant="primary" />
               </div>
            </div>
            <b-table
               :items="topItems"
               :fields="fields"
               responsive
               small
               hover
               borderless
               :tbody-tr-class="'fayankes-row'"
               class="modern-table mb-0"
            >
               <template #cell(index)="{ item }">
                  <span v-if="!item._placeholder">{{ item.index }}</span>
               </template>
               <template #cell(kategori)="{ item }">
                  <b-badge v-if="!item._placeholder" variant="light-primary" class="text-capitalize">
                     {{ item.kategori }}
                  </b-badge>
               </template>
               <template #cell(total)="{ item }">
                  <span v-if="!item._placeholder" class="font-weight-bold text-primary">{{ formatNumber(item.total) }}</span>
               </template>
            </b-table>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
   overflow: hidden;
}

.card-header-content {
   border-bottom: 1px solid #ebe9f1;
}

.modern-table >>> thead th {
   background-color: #f8f8f8;
   color: #6e6b7b;
   font-weight: 600;
   font-size: 0.8rem;
   border: none;
   text-transform: uppercase;
   letter-spacing: 0.5px;
}

.modern-table >>> tbody tr {
   height: 42px;
}

.modern-table >>> tbody td {
   border: none;
   color: #5e5873;
   font-size: 0.875rem;
   vertical-align: middle;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.fayankes-row:hover {
   background-color: #f3f2f7 !important;
}

.dark-layout .card-wrapper {
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.dark-layout .card-header-content {
   border-color: #3b4253;
}

.dark-layout .modern-table >>> thead th {
   background-color: #283046;
   color: #b4b7bd;
}

.dark-layout .modern-table >>> tbody td {
   color: #d0d2d6;
}

.dark-layout .fayankes-row:hover {
   background-color: #343d55 !important;
}
</style>
